import { ɵɵdefinePipe, ɵsetClassMetadata, Pipe, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class StatusPipe {
    transform(column, args) {
        const st = column;
        if (st === 6) {
            return "status-signed";
        }
        else if (st === 5) {
            return "status-signpen";
        }
        else {
            return "";
        }
    }
}
StatusPipe.ɵfac = function StatusPipe_Factory(t) { return new (t || StatusPipe)(); };
StatusPipe.ɵpipe = ɵɵdefinePipe({ name: "statuspipe", type: StatusPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatusPipe, [{
        type: Pipe,
        args: [{
                name: 'statuspipe'
            }]
    }], null, null); })();

class SupervisionStatusPipe {
    transform(value, args) {
        const st = value;
        if (st === 1) {
            return "status-open fas fa-lock-open";
        }
        else if (st === 2) {
            return "status-warning fas fa-cogs";
        }
        else if (st === 3) {
            return "status-open fas fa-cogs";
        }
        else if (st === 4) {
            return "status-pending fas fa-eye";
        }
        else if (st === 5) {
            return "status-error fas fa-exclamation-circle";
        }
        else if (st === 6) {
            return "status-unknown fas fa-exclamation-triangle";
        }
        else if (st === 7) {
            return "status-closed fas fa-lock";
        }
        else {
            return "status-error fas fa-exclamation-circle";
        }
    }
}
SupervisionStatusPipe.ɵfac = function SupervisionStatusPipe_Factory(t) { return new (t || SupervisionStatusPipe)(); };
SupervisionStatusPipe.ɵpipe = ɵɵdefinePipe({ name: "supervstatuspipe", type: SupervisionStatusPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SupervisionStatusPipe, [{
        type: Pipe,
        args: [{
                name: 'supervstatuspipe'
            }]
    }], null, null); })();

class PanelIssueTypePipe {
    transform(value, args) {
        //
        const st = value;
        let res = "";
        if (st === 0) {
            res = "status-pending fas fa-eye";
        }
        else if (st === 1) {
            res = "status-open fas fa-lock-open";
        }
        else if (st === 2) {
            res = "status-warning fas fa-cogs";
        }
        else if (st === 3) {
            res = "status-open fas fa-cogs";
        }
        else if (st === 4) {
            res = "status-wrong fas fa-exclamation-triangle";
        }
        else if (st === 5) {
            res = "status-error fas fa-exclamation-circle";
        }
        else if (st === 6) {
            res = "status-unknown fas fa-exclamation-triangle";
        }
        else if (st === 7) {
            res = "status-closed fas fa-lock";
        }
        else {
            res = "";
        }
        return res;
    }
}
PanelIssueTypePipe.ɵfac = function PanelIssueTypePipe_Factory(t) { return new (t || PanelIssueTypePipe)(); };
PanelIssueTypePipe.ɵpipe = ɵɵdefinePipe({ name: "panelissuetypepipe", type: PanelIssueTypePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PanelIssueTypePipe, [{
        type: Pipe,
        args: [{
                name: 'panelissuetypepipe'
            }]
    }], null, null); })();

class SolarPipesModule {
}
SolarPipesModule.ɵmod = ɵɵdefineNgModule({ type: SolarPipesModule });
SolarPipesModule.ɵinj = ɵɵdefineInjector({ factory: function SolarPipesModule_Factory(t) { return new (t || SolarPipesModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SolarPipesModule, { declarations: [SupervisionStatusPipe, PanelIssueTypePipe, StatusPipe], imports: [CommonModule], exports: [SupervisionStatusPipe,
        PanelIssueTypePipe,
        StatusPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SolarPipesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    SupervisionStatusPipe, PanelIssueTypePipe, StatusPipe
                ],
                exports: [
                    SupervisionStatusPipe,
                    PanelIssueTypePipe,
                    StatusPipe
                ],
            }]
    }], null, null); })();

/*
 * Public API Surface of solarpipes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PanelIssueTypePipe, SolarPipesModule, StatusPipe, SupervisionStatusPipe };
//# sourceMappingURL=solarpipes.js.map
